'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var OIDC_REDIRECTING = exports.OIDC_REDIRECTING = 'OIDC_REDIRECTING';

/**
 * Indicates if application is about to redirect away
 * Invoked when oidc is calling signinredirect or signoutredirect
 * @param {boolean} oidcRedirecting 
 */
var onOidcRedirecting = function onOidcRedirecting(oidcRedirecting) {
  return {
    type: OIDC_REDIRECTING,
    oidcRedirecting: oidcRedirecting
  };
};

exports.default = onOidcRedirecting;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/oidc/actions/OidcRedirectingAction.js
// module id = 342
// module chunks = 10